export default "__VITE_ASSET__BtM_J2Ji__"